import React from 'react';
import ExperiencesStore from '../ExperiencesStore';

export const ExperiencesContext = React.createContext<ExperiencesStore | null>(null);
